import { Container, EventBoundary, FederatedEvent } from 'pixi.js';
import { FloorplanEventTypes, IFloorplanDispatchEvent } from './types';

class FloorplanEventService {
  private rootEl: HTMLElement;
  private container: Container;

  init() {
    this.container = null;
    this.rootEl = null;
  }

  setRootEl(rootEl: HTMLElement) {
    this.rootEl = rootEl;
    this.setRootElEventListener();
  }

  setRootElEventListener() {
    const _this = this;
    this.rootEl.addEventListener(
      'dragover',
      (event) => {
        // prevent default to allow drop
        event.preventDefault();
      },
      false
    );

    // this.rootEl.addEventListener('dragenter', (event) => {
    // });

    // this.rootEl.addEventListener('dragleave', (event) => {
    // });

    this.rootEl.addEventListener('drop', (event) => {
      event.preventDefault();
      _this.dispatchEvent({
        eventType: FloorplanEventTypes.BookingDropEvent,
        eventDetail: event,
      });
    });
  }

  setContainer(container: Container) {
    this.container = container;
  }

  dispatchEvent(event: IFloorplanDispatchEvent) {
    if (this.container) {
      const { eventType, eventDetail } = event;
      const federatedEvent = new FederatedEvent(new EventBoundary(this.container));
      federatedEvent.type = eventType;
      (federatedEvent as any).eventDetail = eventDetail;
      this.container.dispatchEvent(federatedEvent);
    }
  }

  addEventListener(type: FloorplanEventTypes, eventListener: (e?: any) => void) {
    if (this.container) {
      console.log('addEventListener', type);
      this.container.addEventListener(type, eventListener);
    }
  }
}

const instance = new FloorplanEventService();
export default instance as FloorplanEventService;
